import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const PersistedStateWizardContentAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "persisted-state-wizard-content" */ './persisted-state-wizard-content'),
  componentName: 'PersistedStateWizardContent',
});
